import * as Yup from 'yup';
import { EDatasetColumn } from '../types/dataset.types';
import { IOriginTableSettings } from '../types/dataImport.types';

/**
 * @deprecated This schema is kept for backward compatibility with old datasets created before the table settings were stored in the database. It should not be used for new datasets and will be removed in the future.
 */
export const oldTableSettingsSchema = Yup.object().shape({
  coordinatesVersion: Yup.string().oneOf(['lnglat', 'latlng']).default('latlng'),
  farmSizeUnit: Yup.string().oneOf(['ha', 'km2']).default('ha'),
}) as Yup.ObjectSchema;

export const createTableSettingsColumnSchema = (defaultEnabled = false) =>
  Yup.object().shape({
    enabled: Yup.boolean().default(defaultEnabled),
    format: Yup.string().nullable().default(''),
  });

export const originTableSettingsSchema = Yup.object().shape({
  overwriteExisting: Yup.boolean().default(true),
  clusterSites: Yup.boolean().default(true),
  columns: Yup.object()
    .shape({
      originClusterId: Yup.object().shape({
        enabled: Yup.boolean().default(false),
      }),
      farmId: Yup.object().shape({
        enabled: Yup.boolean().default(true),
      }),
      farmName: Yup.object().shape({
        enabled: Yup.boolean().default(true),
      }),
      plotId: Yup.object().shape({
        enabled: Yup.boolean().default(true),
      }),
      plotName: Yup.object().shape({
        enabled: Yup.boolean().default(true),
      }),
      geometry: Yup.object().shape({
        enabled: Yup.boolean().default(true),
        format: Yup.string().default(EDatasetColumn.GEOMETRY_WKT).oneOf([
          EDatasetColumn.GEOMETRY_WKT,
          // EDatasetColumn.COORDINATES_LAT_LNG,
          // EDatasetColumn.COORDINATES_LNG_LAT,
        ]),
      }),
      plotSize: Yup.object().shape({
        enabled: Yup.boolean().default(false),
        format: Yup.string()
          .default(EDatasetColumn.PLOT_SIZE_HA)
          .oneOf([EDatasetColumn.PLOT_SIZE_HA, EDatasetColumn.PLOT_SIZE_KM2]),
      }),
      farmSize: Yup.object().shape({
        enabled: Yup.boolean().default(false),
        format: Yup.string()
          .default(EDatasetColumn.FARM_SIZE_HA)
          .oneOf([EDatasetColumn.FARM_SIZE_HA, EDatasetColumn.FARM_SIZE_KM2]),
      }),

      farmOwnerFullName: Yup.object().shape({
        enabled: Yup.boolean().default(false),
      }),
      farmOwnerFirstName: Yup.object().shape({
        enabled: Yup.boolean().default(false),
      }),
      farmOwnerLastName: Yup.object().shape({
        enabled: Yup.boolean().default(false),
      }),
      landOwnership: Yup.object().shape({
        enabled: Yup.boolean().default(false),
      }),
      numberOfFarmers: Yup.object().shape({
        enabled: Yup.boolean().default(false),
      }),
      additionalCrops: Yup.object().shape({
        enabled: Yup.boolean().default(false),
      }),
      siteDescription: Yup.object().shape({
        enabled: Yup.boolean().default(false),
      }),
    })
    .required(),
}) as Yup.ObjectSchema<IOriginTableSettings>;
